import angular from 'angular';
import customerCards from './customerCardsService';

const moduleName = angular.module('7Shop.CustomerCards', [])
  .service('customerCards', customerCards)
  .name;

export default moduleName;
